if (!wpi) {
  var wpi = {};
}

if (!wpi.mapmodule) {
  wpi.mapmodule = {};
}


wpi.mapmodule.createFeatures = function(layerKey, format, idPath, subObjPath, subObjIdPath, data) {
    //Data format
    var reader, rootGeoObjs;
    if (format === "EsriJson") {
      rootGeoObjs = data.features;
      reader = new ol.format.EsriJSON();
    }
    else if (format === "StandardGeoJson") {
      rootGeoObjs = data.features;
      reader = new ol.format.GeoJSON();
    }
    else {
      rootGeoObjs = data;
      reader = new ol.format.GeoJSON();
    }
    if (!rootGeoObjs) {
      return [];
    }

    //Init info object with root and id
    var geoInfos = [];
    for (var k=0; k<rootGeoObjs.length; k++) {
      var rootId = wpi.mapmodule.getId(rootGeoObjs[k], idPath);
      geoInfos.push({ rootObj: rootGeoObjs[k], rootId: rootId, objs: [{ obj: rootGeoObjs[k], id: rootId }] });
    }

    //Get subobjects if subObjPath (an array) is defined, marking them with the wpiParentId while descending
    var geoInfos = wpi.mapmodule.getSubGeoObjects(geoInfos, subObjPath, subObjIdPath);

    //Iterate geo objects, either root or subobjects with a wpiParentId
    var features = [];
    for (var i=0; i<geoInfos.length; i++) {
        var geoInfo = geoInfos[i];

        for (var j=0; j<geoInfo.objs.length; j++) {
          var geoObj = geoInfo.objs[j].obj;
          var keepTypeFeatureProp = false;
          if (format === "GeoJson") {
            if (!geoObj.geometry || !geoObj.geometry.type || !geoObj.geometry.coordinates
                  || !geoObj.geometry.coordinates.length
                  || geoObj.geometry.coordinates.length === 0 ) continue;
            if (geoObj.type) {
                keepTypeFeatureProp = true;
            }
            geoObj.type = "Feature"; //This invariant is typically not set in our models; necessary to reader below
          }
          var feature = reader.readFeature(geoObj);
          if (format === "GeoJson" && !keepTypeFeatureProp) {
            delete geoObj.type
          }
          feature.setId(geoInfo.objs[j].id);
          feature.wpimodel = geoObj;
          feature.wpiParentId = geoInfo.rootId;
          feature.wpiParentModel = geoInfo.rootObj;
          feature.layerKey = layerKey;
          features.push(feature);
        }
    }
    return features;
};


wpi.mapmodule.waitGetFeaturesFromGeoObjs = function(map, geoObjs, foundFeatures, tries, callback) {
  var missingGeoObjs = [];
  for (var i=0; i<geoObjs.length; i++) {
    var geoObj = geoObjs[i];
    var layer = wpi.mapmodule.findLayerByKey(map, geoObj.layerKey);
    if (!layer) continue;
    var feature = wpi.mapmodule.getVectLayerSrc(layer).getFeatureById(geoObj.id);
    if (feature) {
      foundFeatures.push(feature);
    } else {
      if (!geoObj.obj) continue;
      //Feature not found in layer, maybe not loaded yet: we have to try waiting
      missingGeoObjs.push(geoObj);
    }
  }
  if (missingGeoObjs.length == 0) { //Nothing missing, return result
    callback(foundFeatures);
    return;
  }
  if (tries>12) { //Give up on remaining objs
    callback(foundFeatures);
    return;
  }
  tries++;
  setTimeout(function() {
    wpi.mapmodule.waitGetFeaturesFromGeoObjs(map, missingGeoObjs, foundFeatures, tries, callback);
  }, 1000);
};

// Commented out because adding objects passed from elm may result in features with slightly different data models for the same data,
// for example, missing subdoc ids
// wpi.mapmodule.addFeatureFromObjToLayer = function(layer, obj, id) {
//   if (!layer.wpiVectorProps.idPath && !obj._id) {
//     obj._id = id; //Db objs reencoded from elm may not have kept their _id (not needed for PATCH, POST, DELETE)
//   }
//   var features = wpi.mapmodule.createFeatures(
//     layer.key,
//     layer.wpiVectorProps.format,
//     layer.wpiVectorProps.idPath,
//     layer.wpiVectorProps.subObjPath,
//     layer.wpiVectorProps.subObjIdPath,
//     [ obj ]
//   );
//   wpi.mapmodule.getVectLayerSrc(layer).addFeatures(features);
//   return features[0];
// };


//Get the sub objects in sub-docs using a path of property names (in an array)
wpi.mapmodule.getSubGeoObjects = function(geoInfos, subObjPath, subObjIdPath) {
  if (!subObjPath) return geoInfos;
  for (var i=0; i<subObjPath.length; i++) {
    geoInfos = wpi.mapmodule.getChildObjects(geoInfos, subObjPath[i], subObjIdPath, (subObjPath.length == i+1));
  }
  return geoInfos;
};


//Get the next child object(s); mark them with the parent id
wpi.mapmodule.getChildObjects = function(geoInfos, propName, subObjIdPath, isFinalLevel) {
  for (var i=0; i<geoInfos.length; i++) {
    var geoInfo = geoInfos[i];
    var children = [];

    for (var k=0; k<geoInfo.objs.length; k++) {
      var child = geoInfo.objs[k].obj[propName];
      if (!child) {
        continue; //data could be irregular
      }
      if (!child.length) { //prop is single value
        var id;
        if (isFinalLevel) id = wpi.mapmodule.getId(child, subObjIdPath);
        children.push({ obj: child, id: id });
      } else {
        for (var j=0; j<child.length; j++) { //iterate prop array
          var id;
          if (isFinalLevel) id = wpi.mapmodule.getId(child[j], subObjIdPath);
          children.push({ obj: child[j], id: id });
        }
      }
    }

    geoInfo.objs = children;
  }
  return geoInfos;
};


//Get an id from an object along a path
wpi.mapmodule.getId = function(obj, idPath) {
  if (!idPath || !idPath.length) {
    idPath = ["_id"]; //default
  }
  var idVal = obj;
  for (var i=0; i<idPath.length; i++) {
    idVal = idVal[idPath[i]]
  }
  return idVal;
};


wpi.mapmodule.getFeaturesFromSelIA = function(selIA) {
  var features = selIA.getFeatures().getArray();
  var actFeatures = [];
  for (var i=0; i<features.length; i++) {
    if (features[i].get('features')) {
      actFeatures = actFeatures.concat(features[i].get('features')); //cluster case
    }
    else {
      actFeatures.push(features[i]);
    }
  }
  return actFeatures;
};
